export default __webpack_public_path__ + "static/media/minus.d84f62a1.svg";